import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';

export interface CalendarEvent {
  title: string;
  description: string;
  location: string;
  start: Date;
  end: Date;
  timezone: string;
}

function formatDateForICS(date: Date): string {
  return format(date, "yyyyMMdd'T'HHmmss");
}

export function generateICS(event: CalendarEvent): string {
  const icsContent = [
    'BEGIN:VCALENDAR',
    'VERSION:2.0',
    'PRODID:-//NextAgency//Booking//EN',
    'BEGIN:VEVENT',
    `DTSTART;TZID=${event.timezone}:${formatDateForICS(event.start)}`,
    `DTEND;TZID=${event.timezone}:${formatDateForICS(event.end)}`,
    `SUMMARY:${event.title}`,
    `DESCRIPTION:${event.description.replace(/\n/g, '\\n')}`,
    `LOCATION:${event.location}`,
    'END:VEVENT',
    'END:VCALENDAR'
  ].join('\r\n');

  return icsContent;
}

export function downloadICS(event: CalendarEvent): void {
  const icsContent = generateICS(event);
  const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
  const link = document.createElement('a');
  link.href = URL.createObjectURL(blob);
  link.download = 'nextagency-booking.ics';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export function getGoogleCalendarUrl(event: CalendarEvent): string {
  const startStr = formatInTimeZone(event.start, 'UTC', "yyyyMMdd'T'HHmmss'Z'");
  const endStr = formatInTimeZone(event.end, 'UTC', "yyyyMMdd'T'HHmmss'Z'");

  const params = new URLSearchParams({
    action: 'TEMPLATE',
    text: event.title,
    dates: `${startStr}/${endStr}`,
    details: event.description,
    location: event.location,
    ctz: event.timezone
  });

  return `https://calendar.google.com/calendar/render?${params}`;
}

export function getOutlookCalendarUrl(event: CalendarEvent): string {
  const startStr = event.start.toISOString();
  const endStr = event.end.toISOString();

  const params = new URLSearchParams({
    path: '/calendar/action/compose',
    rru: 'addevent',
    subject: event.title,
    body: event.description,
    location: event.location,
    startdt: startStr,
    enddt: endStr
  });

  return `https://outlook.live.com/calendar/0/deeplink/compose?${params}`;
}
